import { captureTypedPosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';

export type ProjectManagerSelfAssignInput = {
  projectId: string;
  organizationId?: string;
  meId?: string;
  /** Field names that were actually persisted by the save. */
  savedFields: string[];
  savedProjectManagerId?: string | null;
  previousProjectManagerId?: string | null;
  /** True when the save came from the "Assign to me" shortcut rather than the select. */
  viaAssignToMeButton: boolean;
};

/** Captures `project_manager_self_assigned` when a saved edit made the current user the PM. */
export function trackProjectManagerSelfAssigned(input: ProjectManagerSelfAssignInput): void {
  const {
    projectId,
    organizationId,
    meId,
    savedFields,
    savedProjectManagerId,
    previousProjectManagerId,
    viaAssignToMeButton,
  } = input;

  if (!meId) return;
  if (!savedFields.includes('projectManagerId')) return;
  if (savedProjectManagerId !== meId) return;
  if (previousProjectManagerId === meId) return;

  captureTypedPosthogEvent(POSTHOG_EVENTS.projectManagerSelfAssigned, {
    project_id: projectId,
    organization_id: organizationId,
    previous_project_manager_id: previousProjectManagerId ?? null,
    source: viaAssignToMeButton ? 'assign_to_me_button' : 'project_manager_select',
  });
}
